import React from 'react';

import { translate } from 'admin-on-rest';
import { Field } from 'redux-form';
import { TextField } from 'material-ui';

const renderTextField = ({ input, meta: { touched, error }, label, ...custom }) => (
  <TextField
    {...input}
    {...custom}
    errorText={touched && error}
  />);

const PercentageInput = ({ source }) => (
  <Field
    name={source}
    format={(v = 0) => `${v * 100} %`}
    parse={(v = 0) => parseInt(v.replace('%', '').trim(), 10) / 100}
    component={renderTextField}
    type="text"
  />
);

PercentageInput.defaultProps = {
  addLabel: true,
  addField: false,
};

export default translate(PercentageInput);
